import { render, staticRenderFns } from "./OrganicWaste.vue?vue&type=template&id=d89cb82c&scoped=true"
import script from "./OrganicWaste.vue?vue&type=script&lang=js"
export * from "./OrganicWaste.vue?vue&type=script&lang=js"
import style0 from "./OrganicWaste.vue?vue&type=style&index=0&id=d89cb82c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_1c848d52c9dbe574bb8312e4e1e1d32e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d89cb82c",
  null
  
)

export default component.exports